/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Email_Assignee_ChangedInputs */

const en_api_error_task_email_assignee_changed = /** @type {(inputs: Api_Error_Task_Email_Assignee_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The task was reassigned before the email was sent.`)
};

const pt_br2_api_error_task_email_assignee_changed = /** @type {(inputs: Api_Error_Task_Email_Assignee_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tarefa foi reatribuída antes do envio do e-mail.`)
};

/**
* | output |
* | --- |
* | "The task was reassigned before the email was sent." |
*
* @param {Api_Error_Task_Email_Assignee_ChangedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_email_assignee_changed = /** @type {((inputs?: Api_Error_Task_Email_Assignee_ChangedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Email_Assignee_ChangedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_email_assignee_changed(inputs)
	return pt_br2_api_error_task_email_assignee_changed(inputs)
});